import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_onboarding/onboarding/my-plan/')({
  beforeLoad: () => {
    // @ts-expect-error strictNullChecks breaks TanStack Router inference
    throw redirect({ to: '/onboarding/my-plan/$step', params: { step: '1' } });
  },
});
